import { Guid, Nillable } from '@web/utils';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { WarehouseRestockType } from '../enums/warehouse-restock-type';

export type WarehouseRestockControls = {
  restockedAt: FormControl<Date>;
  type: FormControl<WarehouseRestockType>;
  shippingNumber: FormControl<Nillable<string>>;
  person: WarehouseRestockPersonFormGroup;
  comment: FormControl<Nillable<string>>;
  products: FormArray<WarehouseRestockProductFormGroup>;
  fileIds: FormControl<Nillable<Guid[]>>;
};

export type WarehouseRestockPersonControls = {
  dignity: FormControl<Nillable<string>>;
  email: FormControl<Nillable<string>>;
  phone: FormControl<Nillable<string>>;
};

export type WarehouseRestockProductControls = {
  id: FormControl<Nillable<Guid>>;
  quantity: FormControl<Nillable<number>>;
};

export class WarehouseRestockFormData {
  public static readonly MaxCommentLength = 50000;
  public static readonly MaxShippingNumberLength = 50000;

  public constructor(
    private data: {
      comment?: Nillable<string>;
      person?: Nillable<WarehouseRestockPersonFormData>;
      restockedAt: Date;
      shippingNumber?: Nillable<string>;
      type: WarehouseRestockType;
      products: WarehouseRestockProductFormData[];
      fileIds?: Nillable<Guid[]>;
    },
  ) {}

  public get restockedAt(): Date {
    return this.data.restockedAt;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get person(): Nillable<WarehouseRestockPersonFormData> {
    return this.data.person;
  }

  public get shippingNumber(): Nillable<string> {
    return this.data.shippingNumber;
  }

  public get type(): WarehouseRestockType {
    return this.data.type;
  }

  public get products(): WarehouseRestockProductFormData[] {
    return this.data.products;
  }

  public get fileIds(): Nillable<Guid[]> {
    return this.data.fileIds;
  }
}

export class WarehouseRestockPersonFormData {
  public constructor(
    private data: {
      dignity?: Nillable<string>;
      phone?: Nillable<string>;
      email?: Nillable<string>;
    },
  ) {}

  public get dignity(): Nillable<string> {
    return this.data.dignity;
  }

  public get phone(): Nillable<string> {
    return this.data.phone;
  }

  public get email(): Nillable<string> {
    return this.data.email;
  }
}

export class WarehouseRestockProductFormData {
  public constructor(
    private data: {
      id?: Nillable<Guid>;
      productId: Guid;
      quantity: number;
    },
  ) {}

  public get id(): Nillable<Guid> {
    return this.data.id;
  }

  public get productId(): Guid {
    return this.data.productId;
  }

  public get quantity(): number {
    return this.data.quantity;
  }
}

/* prettier-ignore */
export type WarehouseRestockFormGroup = FormGroup<WarehouseRestockControls>;

/* prettier-ignore */
export type WarehouseRestockPersonFormGroup = FormGroup<WarehouseRestockPersonControls>;

/* prettier-ignore */
export type WarehouseRestockProductFormGroup = FormGroup<WarehouseRestockProductControls>;
